import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { MastheadComponentComponent } from './masthead-component/masthead-component.component';
import { RouterModule, Routes } from '@angular/router';
import { NgProgressbar, provideNgProgressOptions } from 'ngx-progressbar';
import { NgProgressHttp, progressInterceptor } from 'ngx-progressbar/http';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { CardComponent } from './card/card.component';
import { PartAttachmentComponent } from './part-attachment/part-attachment.component';
import { OsLangComponent } from './os-lang/os-lang.component';
import { HomeComponent } from './home/home.component';
import { LandingComponent } from './landing/landing.component';
import { AccToggleComponent } from './acc-toggle/acc-toggle.component';
import { CheckboxOslangComponent } from './checkbox-oslang/checkbox-oslang.component';
import { AttachFileComponent } from './attach-file/attach-file.component';
import { FileExplorerComponent } from './modals/file-explorer/file-explorer.component';
import { LoadingComponent } from './loading/loading.component';
import { DataService } from './data.service';
import { InfoModalComponent } from './modal/info-modal/info-modal.component';
import { PartInfoModalComponent } from './modal/part-info-modal/part-info-modal.component';
import { FileCatalystModalComponent } from './modal/file-catalyst-modal/file-catalyst-modal.component';
import { HardwareRelationshipMappingComponent } from './hardware-relationship-mapping/hardware-relationship-mapping.component';
import { FileTypeFilterPipe } from './attach-file/file-type-filter.pipe';
import { SortDirective } from './util/sort.directive';
import { TransferStatusV2Component } from './transfer-status-v2/transfer-status-v2.component';
import { UserGuidesComponent } from './user-guides/user-guides.component';


const appRoutes: Routes = [
  { path: '', component: AppComponent},
  { path: 'au', component: AppComponent},
  { path: 'home', component: HomeComponent},
  { path: 'oslang', component: OsLangComponent},
  { path: 'transferstatus_v2', component: TransferStatusV2Component},
  { path: 'relmapping', component: HardwareRelationshipMappingComponent},
  { path: 'userguides', component: UserGuidesComponent},
]; 

@NgModule({ declarations: [
        AppComponent,
        MastheadComponentComponent,
        FooterComponent,
        CardComponent,
        PartAttachmentComponent,
        OsLangComponent,
        HomeComponent,
        LandingComponent,
        AccToggleComponent,
        CheckboxOslangComponent,
        AttachFileComponent,
        FileExplorerComponent,
        LoadingComponent,
        InfoModalComponent,
        PartInfoModalComponent,
        FileCatalystModalComponent,
        HardwareRelationshipMappingComponent,
        FileTypeFilterPipe,
        SortDirective,
        TransferStatusV2Component,
        UserGuidesComponent
    ],
    bootstrap: [AppComponent], imports: [
        BrowserModule,
        NgProgressbar,
        NgProgressHttp,
        RouterModule.forRoot(appRoutes),
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        
    
    ], providers: [DataService, provideHttpClient(withInterceptors([progressInterceptor])),
      provideNgProgressOptions({
      spinnerPosition: 'left',
    }),
    ] })
export class AppModule { }
